<template>
    <section>
        <base-card>
            <h2>Page Not Found</h2>
            <p>This Page Could not be found maybe check again <router-link to="/coaches">Coaches</router-link></p>
        </base-card>
    </section>

</template>